import React from 'react';
import cn from '@/utils/cn';
import SPADropdown from './SPADropdown';

// AIDEV-NOTE: The signed-in user's menu (name → Sign Out) for unified-nav chrome — the rail
// footer and the welcome page's corner cluster. Radix flips the menu to fit the viewport, so
// the same component works pinned to the bottom or the top of the screen.

interface SPAAccountMenuProps {
  className?: string;
  signOutPath: string;
  userName: string;
}

const SPAAccountMenu = ({ className, signOutPath, userName }: SPAAccountMenuProps) => (
  <SPADropdown>
    <SPADropdown.Trigger asChild>
      <button
        aria-label={`${userName} account menu`}
        className={cn(
          'tw-flex tw-min-w-0 tw-cursor-pointer tw-items-center tw-rounded-md',
          'tw-border-0 tw-bg-transparent tw-px-2 tw-py-1.5 tw-text-left tw-text-sm',
          'tw-text-spa-primary hover:tw-bg-spa-bg-tertiary hover:tw-text-spa-high-contrast',
          className,
        )}
        type="button"
      >
        <span className="tw-min-w-0 tw-truncate">{userName}</span>
      </button>
    </SPADropdown.Trigger>
    <SPADropdown.Content align="start">
      <SPADropdown.Item asChild>
        <a data-method="delete" href={signOutPath}>
          Sign Out
        </a>
      </SPADropdown.Item>
    </SPADropdown.Content>
  </SPADropdown>
);

export default SPAAccountMenu;
